import clsx from 'clsx';
import { ComponentPropsWithoutRef, forwardRef } from 'react';

import styles from './TanStackTable.module.scss';

export const TanStackTableRoot = forwardRef<
  HTMLTableElement,
  ComponentPropsWithoutRef<'table'>
>(({ className, ...props }, ref) => (
  <table ref={ref} className={clsx(styles.root, className)} {...props} />
));

TanStackTableRoot.displayName = 'TanStackTableRoot';
